import { EncryptStorage } from "encrypt-storage";

const secretKey = process.env.REACT_APP_SECRET_KEY;

if (!secretKey || secretKey.length !== 32) {
  throw new Error(
    "REACT_APP_SECRET_KEY is missing or not 32 characters! Check your .env"
  );
}

export const secureStorage = new EncryptStorage(secretKey, {
  prefix: "@dhroobin:",
});
